<template>
    <div>
        <span
            class="flex items-center transform mr-4"
            :class="[isOpen ? 'hidden' : '-close']"
            
        >
            <svg
                :class="`${block}__icon`"
                :width="width"
                :height="height"
                viewBox="0 0 100 100"
                style="enable-background: new 0 0 100 100"
            >
                <path
                    class="st0"
                    d="M60.2,61.85H6.94V38.06h32.71V0.25H60.2V61.85z"
                />
                <path
                    class="st1"
                    d="M60.34,99.75H39.78v-61.6h53.28v23.79H60.34V99.75z"
                />
            </svg>
        </span>
        <span
            class="flex items-center transform mr-4"
            :class="[isOpen ? '-open' : 'hidden']"
        >
            <svg
                :class="`${block}__icon`"
                width="24"
                height="24"
                viewBox="0 0 100 100"
                style="enable-background: new 0 0 100 100"
            >
                <polygon
                    class="st0"
                    points="6.94,38.15 6.94,61.85 93.06,61.85 93.06,38.15 60.2,38.15 "
                />
            </svg>
        </span>
    </div>
</template>

<script>

export default {
    name: "iconPlus",
    props: {
        block: {
            type: String,
            default: "accordion",
        },
        width: {
            type: [Number, String],
            default: 24,
        },
        height: {
            type: [Number, String],
            default: 24,
        },
        isOpen: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        console.log(this.$props);
        console.log(this.$attrs);
    }
};
</script>

